import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as taxbillApi from '../../lib/api/taxbill';

const [
  LIST_PROJECT_INIT_BUY_TAXBILLS,
  LIST_PROJECT_INIT_BUY_TAXBILLS_SUCCESS,
  LIST_PROJECT_INIT_BUY_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_INIT_BUY_TAXBILLS');

export const listProjectInitBuyTaxbills = createAction(
  LIST_PROJECT_INIT_BUY_TAXBILLS,
  (id) => id,
);
const listProjectInitBuyTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_INIT_BUY_TAXBILLS,
  taxbillApi.getProjectInitBuyTaxbill,
);

const [
  LIST_PROJECT_INIT_SALES_TAXBILLS,
  LIST_PROJECT_INIT_SALES_TAXBILLS_SUCCESS,
  LIST_PROJECT_INIT_SALES_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_INIT_SALES_TAXBILLS');

export const listProjectInitSalesTaxbills = createAction(
  LIST_PROJECT_INIT_SALES_TAXBILLS,
  (id) => id,
);
const listProjectInitSalesTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_INIT_SALES_TAXBILLS,
  taxbillApi.getProjectInitSalesTaxbill,
);

const [
  LIST_PROJECT_BUY_TAXBILLS,
  LIST_PROJECT_BUY_TAXBILLS_SUCCESS,
  LIST_PROJECT_BUY_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_BUY_TAXBILLS');

export const listProjectBuyTaxbills = createAction(
  LIST_PROJECT_BUY_TAXBILLS,
  (id) => id,
);
const listProjectBuyTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_BUY_TAXBILLS,
  taxbillApi.getIssuedBuyTaxbills,
);

const [
  LIST_PROJECT_SALES_TAXBILLS,
  LIST_PROJECT_SALES_TAXBILLS_SUCCESS,
  LIST_PROJECT_SALES_TAXBILLS_FAILURE,
] = createRequestActionTypes('project/LIST_PROJECT_SALES_TAXBILLS');

export const listProjectSalesTaxbills = createAction(
  LIST_PROJECT_SALES_TAXBILLS,
  (id) => id,
);
const listProjectSalesTaxbillsSaga = createRequestSaga(
  LIST_PROJECT_SALES_TAXBILLS,
  taxbillApi.getIssuedSalesTaxbills,
);

export function* issuedTaxbillsSaga() {
  yield takeLatest(
    LIST_PROJECT_INIT_BUY_TAXBILLS,
    listProjectInitBuyTaxbillsSaga,
  );
  yield takeLatest(
    LIST_PROJECT_INIT_SALES_TAXBILLS,
    listProjectInitSalesTaxbillsSaga,
  );
  yield takeLatest(LIST_PROJECT_BUY_TAXBILLS, listProjectBuyTaxbillsSaga);
  yield takeLatest(LIST_PROJECT_SALES_TAXBILLS, listProjectSalesTaxbillsSaga);
}

const initialState = {
  initBuyTaxbills: null,
  initSalesTaxbills: null,
  buyTaxbills: null,
  salesTaxbills: null,
  error: null,
};

const issueTaxbills = handleActions(
  {
    [LIST_PROJECT_INIT_BUY_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      initBuyTaxbills: data.list.map((init) => ({
        ...init,
        buyDiv: 1,
      })),
      error: null,
    }),
    [LIST_PROJECT_INIT_BUY_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [LIST_PROJECT_INIT_SALES_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      initSalesTaxbills: data.list.map((init) => ({
        ...init,
        buyDiv: 1,
      })),
      error: null,
    }),
    [LIST_PROJECT_INIT_SALES_TAXBILLS_FAILURE]: (
      state,
      { payload: error },
    ) => ({
      ...state,
      error: error,
    }),
    [LIST_PROJECT_BUY_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      buyTaxbills: data.list,
      error: null,
    }),
    [LIST_PROJECT_BUY_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [LIST_PROJECT_SALES_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      salesTaxbills: data.list,
      error: null,
    }),
    [LIST_PROJECT_SALES_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
  },
  initialState,
);

export default issueTaxbills;
